app.service('productDetailsGallery', function (carouselSlider) {
	let $self, $galleryMainImageBox, $galleryThumbnail;

	function setElements() {
		$galleryMainImageBox = $self.find('.js-gallery-main-image');
		$galleryThumbnailButton = $self.find('.js-gallery-thumbnail');
		$galleryThumbnailListItem = $galleryThumbnailButton.closest('.product-gallery-thumbnails-list-item');
	}

	function setEvents() {
		$self.on('click', '.js-gallery-show-previous', function () {
			if ($galleryThumbnailListItem.filter('.is-active').is(':first-child')) {
				$galleryThumbnailListItem.last().addClass('is-active').siblings().removeClass('is-active');
			} else {
				$galleryThumbnailListItem.filter('.is-active').prev().addClass('is-active').siblings().removeClass('is-active');
			}
			checkActiveThumbnailPosition();
			$galleryMainImageBox.find('img').attr('src', $galleryThumbnailListItem.filter('.is-active').find('img').attr('src'));
		}).on('click', '.js-gallery-show-next', function () {
			if ($galleryThumbnailListItem.filter('.is-active').is(':last-child')) {
				$galleryThumbnailListItem.first().addClass('is-active').siblings().removeClass('is-active');
			} else {
				$galleryThumbnailListItem.filter('.is-active').next().addClass('is-active').siblings().removeClass('is-active');
			}
			checkActiveThumbnailPosition();
			$galleryMainImageBox.find('img').attr('src', $galleryThumbnailListItem.filter('.is-active').find('img').attr('src'));
		}).on('click', '.js-gallery-thumbnail', function () {
			$(this).closest('.product-gallery-thumbnails-list-item').addClass('is-active').siblings().removeClass('is-active');
			$galleryMainImageBox.find('img').attr('src', $(this).find('img').attr('src'));
		});
	}
	function checkActiveThumbnailPosition() {
		const $activeThumbnail = $galleryThumbnailListItem.filter('.is-active');
		const $thumbnailsList = $activeThumbnail.closest('.product-gallery-thumbnails-list');

		if (!$activeThumbnail.length || !$thumbnailsList.length) {
			return;
		}

		const thumbnailsListElement = $thumbnailsList.get(0);
		const activeThumbnailElement = $activeThumbnail.get(0);
		const thumbnailsListRect = thumbnailsListElement.getBoundingClientRect();
		const activeThumbnailRect = activeThumbnailElement.getBoundingClientRect();
		const thumbnailsListScrollLeft = $thumbnailsList.scrollLeft();

		if (activeThumbnailRect.left < thumbnailsListRect.left) {
			// Sprawdzenie czy element wychodzi poza lewą krawędź
			const deltaToLeftEdge = (thumbnailsListRect.left) - activeThumbnailRect.left;
			const newScrollLeft = Math.max(0, thumbnailsListScrollLeft - deltaToLeftEdge);
			$thumbnailsList.scrollLeft(newScrollLeft);
		} else if (activeThumbnailRect.right > thumbnailsListRect.right) {
			// Sprawdzenie czy element wychodzi poza prawą krawędź
			const deltaToRightEdge = activeThumbnailRect.right - (thumbnailsListRect.right);
			const newScrollLeft = Math.max(0, thumbnailsListScrollLeft + deltaToRightEdge);
			$thumbnailsList.scrollLeft(newScrollLeft);
		}
	}

	function init($gallery) {
		$self = $gallery;
		if ($self && $self.length && $self.find('.product-gallery-thumbnails-box').length) {
			setElements();
			setEvents();
		}
	}

	return {
		init
	};
});
